<div class="dev-role-switcher" *ngIf="impersonationService.isDevMode()">
	<div class="dev-switcher-container">
		<!-- Close Dev Mode Button -->
		<div class="dev-mode-close" (click)="onCloseDevMode()" matTooltip="Close Dev Mode">
			<mat-icon class="close-icon">close</mat-icon>
		</div>

		<div class="switcher-trigger" (click)="toggleExpanded()" [class.expanded]="isExpanded">
			<span class="trigger-icon">🔧</span>
			<span class="trigger-text" *ngIf="isExpanded">Close</span>
			<span class="trigger-text" *ngIf="!isExpanded">
				{{ getTriggerText() }}
			</span>
		</div>
	</div>

	<div class="switcher-panel" *ngIf="isExpanded">
		<div class="panel-header">
			<h4>Dev Role Override</h4>
			<button mat-icon-button (click)="toggleExpanded()" class="close-btn" matTooltip="Close">
				<mat-icon>close</mat-icon>
			</button>
		</div>

		<div class="panel-content">
			<div class="form-group">
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Role</mat-label>
					<mat-select [(value)]="selectedRole" (selectionChange)="onRoleChange($event.value)">
						<mat-option [value]="null">None (Use Real Role)</mat-option>
						<mat-option *ngFor="let role of roles" [value]="role.value">
							{{ role.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<!-- Distributor Admin: Only show distributor -->
			<div class="form-group" *ngIf="selectedRole === 'distiadmin'">
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Distributor</mat-label>
					<mat-select [(value)]="selectedDistiId" (selectionChange)="onDistiChange($event.value)" [disabled]="loadingDistributors">
						<mat-option [value]="null">Select Distributor</mat-option>
						<mat-option *ngFor="let disti of distributors" [value]="disti.value">
							{{ disti.label }}
						</mat-option>
					</mat-select>
					<mat-spinner *ngIf="loadingDistributors" diameter="20" class="spinner"></mat-spinner>
				</mat-form-field>
			</div>

			<!-- Market Admin: Show distributor and market -->
			<div class="form-group" *ngIf="selectedRole === 'marketadmin'">
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Distributor</mat-label>
					<mat-select [(value)]="selectedDistiId" (selectionChange)="onDistiChange($event.value)" [disabled]="loadingDistributors">
						<mat-option [value]="null">Select Distributor</mat-option>
						<mat-option *ngFor="let disti of distributors" [value]="disti.value">
							{{ disti.label }}
						</mat-option>
					</mat-select>
					<mat-spinner *ngIf="loadingDistributors" diameter="20" class="spinner"></mat-spinner>
				</mat-form-field>
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Market</mat-label>
					<mat-select [(value)]="selectedMarketId" (selectionChange)="onMarketChange($event.value)" [disabled]="loadingMarkets || !selectedDistiId">
						<mat-option [value]="null">Select Market</mat-option>
						<mat-option *ngFor="let market of markets" [value]="market.value">
							{{ market.label }}
						</mat-option>
					</mat-select>
					<mat-spinner *ngIf="loadingMarkets" diameter="20" class="spinner"></mat-spinner>
				</mat-form-field>
			</div>

			<!-- Client Admin: Only show client -->
			<div class="form-group" *ngIf="selectedRole === 'clientadmin'">
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Client</mat-label>
					<mat-select [(value)]="selectedClientId" (selectionChange)="onClientChange($event.value)" [disabled]="loadingClients">
						<mat-option [value]="null">Select Client</mat-option>
						<mat-option *ngFor="let client of clients" [value]="client.value">
							{{ client.label }}
						</mat-option>
					</mat-select>
					<mat-spinner *ngIf="loadingClients" diameter="20" class="spinner"></mat-spinner>
				</mat-form-field>
			</div>

			<!-- Campus Admin: Only show campus -->
			<div class="form-group" *ngIf="isCampusScopedRole(selectedRole)">
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Campus</mat-label>
					<mat-select [(value)]="selectedCampusId" (selectionChange)="onCampusChange($event.value)" [disabled]="loadingCampuses">
						<mat-option [value]="null">Select Campus</mat-option>
						<mat-option *ngFor="let campus of campuses" [value]="campus.value">
							{{ campus.label }}
						</mat-option>
					</mat-select>
					<mat-spinner *ngIf="loadingCampuses" diameter="20" class="spinner"></mat-spinner>
				</mat-form-field>
			</div>

			<!-- Reset button -->
			<div class="form-group reset-section" *ngIf="currentToken">
				<button mat-raised-button color="warn" (click)="clearOverride()" class="reset-btn full-width">
					<mat-icon>refresh</mat-icon>
					<span>Reset to Actual Role</span>
				</button>
			</div>

			<!-- Save button -->
			<div class="form-group save-section">
				<button mat-raised-button color="primary" (click)="saveAndClose()" class="save-btn full-width" [disabled]="loadingImpersonation">
					<mat-spinner *ngIf="loadingImpersonation" diameter="20" class="spinner-inline"></mat-spinner>
					<mat-icon *ngIf="!loadingImpersonation">save</mat-icon>
					<span>{{ loadingImpersonation ? 'Impersonating...' : 'Save' }}</span>
				</button>
			</div>

			<div class="panel-footer" *ngIf="currentToken">
				<small class="override-info">
					<strong>Impersonation active:</strong> {{ getRoleLabel(currentToken.role, currentToken.portalView) }}
					<span *ngIf="currentToken.distiId"> | Disti: {{ currentToken.distiId }}</span>
					<span *ngIf="currentToken.marketId"> | Market: {{ currentToken.marketId }}</span>
					<span *ngIf="currentToken.clientId"> | Client: {{ currentToken.clientId }}</span>
					<span *ngIf="currentToken.campusId"> | Campus: {{ currentToken.campusId }}</span>
				</small>
			</div>
		</div>
	</div>
</div>

